import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Typsnittet ligger på vår egen server (inga anrop till Google, inga IP-adresser till tredje part).
import '@fontsource-variable/plus-jakarta-sans/wght.css';
import '@fontsource-variable/plus-jakarta-sans/wght-italic.css';
import './index.css';
import './components/store/coffeenova/coffeenova.css';
import { captureUtm, startAnalytics } from './services/attribution';
import { readPendingCheckout, stripeReturnParams } from './services/stripeClient';

// UTM-koden ligger före # och finns bara i adressen vid första sidvisningen.
captureUtm();
// Google Analytics startar bara om besökaren redan har godkänt statistik.
startAnalytics();

// Tillbaka från Stripe (Swish, Klarna, 3D Secure): Stripe skickar kunden till
// sidans rot. Gå tillbaka till butikssidan, med Stripes parametrar kvar, så
// att kassan kan visa tacksidan.
if (stripeReturnParams()) {
  const pending = readPendingCheckout();
  if (pending) window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${pending.hash}`);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);